import {
  ListingInquiryDto,
  ListingDto,
  ListingImageDto,
} from '../dtos/listing.dto';
import { Signal, WritableSignal } from '@angular/core';
import { Result } from '../models/http-response.model';
import {
  ListingModel,
  ListingQueryParams,
  ListingCollectionModel,
} from '../models/listing.model';
import { ListingInquiryResponse } from '../../data/repositories/listings/listings.responses';

export abstract class ListingsRepository {
  abstract getListings(
    params: ListingQueryParams
  ): Promise<Result<ListingCollectionModel, Error>>;
  abstract getMyListings(
    params: ListingQueryParams
  ): Promise<Result<ListingCollectionModel, Error>>;
  abstract createListing(
    newListing: ListingDto
  ): Promise<Result<ListingModel, Error>>;
  abstract updateListing(
    slug: string,
    listing: ListingDto
  ): Promise<Result<unknown, Error>>;
  abstract updateListingImages(
    idOrSlug: string,
    images: ListingImageDto[]
  ): Promise<Result<unknown, Error>>;
  abstract getListingBySlug(slug: string): Promise<Result<ListingModel, Error>>;
  abstract getListingById(id: string): Promise<Result<ListingModel, Error>>;
  abstract listingInquiry(
    listingInquiryDto: ListingInquiryDto
  ): Promise<Result<ListingInquiryResponse, Error>>;
  abstract deleteListing(id: string): Promise<Result<unknown, Error>>;
}
